import { format } from "date-fns";
import i18n from "../i18n";
import { getDateFnsLocale } from "./getDateFnsLocale";

// date-fns' "do" (ordinal day) token renders as "10º" in Spanish, which isn't
// how Spanish dates are written ("miércoles 5 de agosto"), so each caller
// supplies matching en/es patterns instead of one pattern shared across locales.
export const formatLocalizedDate = (date, { en, es }) => {
  const isEs = i18n.language?.startsWith("es");
  return format(date, isEs ? es : en, { locale: getDateFnsLocale() });
};
